export const UPDATE_SELECTED_PAGE = 'UPDATE_SELECTED_PAGE'
export const UPDATE_SUB_PAGE = 'UPDATE_SUB_PAGE'
